
import { useStore } from '@/store';
import { Mutations } from '@/store/Mutations';
import { defineComponent } from 'vue';
import UseIcon from '../UseIcon/UseIcon.vue';

interface SetupReturn {
    goBack(): void;
}

export default defineComponent({
    components: {
        UseIcon,
    },
    setup(): SetupReturn {
        const store = useStore();

        const goBack = (): void => {
            store.commit(Mutations.RESET_STORE);
        };

        return {
            goBack,
        };
    },
});
